import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { BsArrowRightShort } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import "./style.min.css";
const ProcessSteps = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const steps = t("process.steps", { returnObjects: true });

  return (
    <section
      id="process"
      className="backgroundIssu py-24 px-6 lg:px-20 text-center  text-[var(--color_text)]"
      dir={lang === "ar" ? "rtl" : "ltr"}
      data-aos="fade-up"
      data-aos-once="false" // Animation visible à chaque scroll
    >
      {/* 🔷 Titre avec gradient ou primary */}
      <h2
        className="title-gradient work-title"
        data-aos="fade-up"
      >
        {t("process.title")}
      </h2>

      <div className="flex flex-col md:flex-row justify-center items-center gap-12 max-w-6xl mx-auto">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* 🔹 Step card */}
            <div
              className="flex flex-col items-center text-center max-w-[200px]"
              data-aos="fade-up"
              data-aos-delay={index * 150}
              data-aos-once="false"
            >
              <div className="w-16 h-16 rounded-full border-2 border-[var(--primary)] flex items-center justify-center text-lg font-bold text-[var(--primary)] mb-4">
                {step.id}
              </div>

              <h3 className="text-md font-semibold text-[var(--primary)] mb-2">
                {step.title}
              </h3>

              <p className="text-sm text-[var(--body_color)] leading-relaxed">
                {step.desc}
              </p>
            </div>

            {/* ➡️ Grande flèche moderne sauf dernier élément */}
            {index < steps.length - 1 && (
              <BsArrowRightShort
                className={`text-[var(--primary)] text-8xl hidden md:block ${
                  lang === "ar" ? "rotate-180" : ""
                }`}
                data-aos="fade-left"
                data-aos-delay={index * 150 + 100}
                data-aos-once="false"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default ProcessSteps;
